import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3ff94436"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "business" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "business_title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Treated with Warmth, Not Just the Pills"),
  /*#__PURE__*/_createElementVNode("p", { class: "dec" }, " Discover practitioners and services to improve your health and wellbeing with Sixliv. "),
  /*#__PURE__*/_createElementVNode("p", null, " We don’t just treat diseaseswe enhance your overall health and quality of life. ")
], -1))
const _hoisted_3 = { class: "business_cards" }
const _hoisted_4 = { class: "sign" }

import BusinessCard from "./BusinessCard.vue";
import { useData } from "@/utils/store";
import { onMounted, reactive, watchEffect } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Treated',
  setup(__props) {

const pageData=useData()

const pics = reactive<{
  pic: { url: string; title: string; content: string; digest: string }[];
}>({
  pic: [],
});
watchEffect(() => {
  const {FUN_ZONE}=pageData.globalData.value
  if(FUN_ZONE){
    pics.pic=FUN_ZONE[1].children
  }
})
onMounted(() => {
  if (localStorage.getItem("FUN_ZONE")) {
    pics.pic = JSON.parse(localStorage.getItem("FUN_ZONE") || "")[1].children || [];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pics.pic, (item) => {
        return (_openBlock(), _createBlock(BusinessCard, {
          key: item.url,
          title: item.title,
          url: item.url,
          content: item.content,
          digest: item.digest
        }, null, 8, ["title", "url", "content", "digest"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        to: "signup",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.store.handleOpenLogin && _ctx.store.handleOpenLogin(...args))),
        class: "sign"
      }, "Sign Up")
    ])
  ]))
}
}

})